<template>
    <div class="mainDiv">
        <div class="logo" @click="goToTOP()">
            <div>
                <img height="24" width="24" src="../../../assets/logo/krishifyLogo.svg" />
            </div>
            <div class="logoTextdiv">
                <p class="logoText">Krishify Business</p>
            </div>
        </div>
        <!-- <div class="navigationTabs">
            <div class="AdvertisementTab" style="cursor: pointer" @click="handleClickadvertise()">
                <p class="tabText">Advertise with Krishify</p>
            </div>
            <div class="StartSellingTab" style="cursor: pointer" @click="handleClickselling()">
                <p class="tabText">Start Selling</p>
            </div>
            <div class="EngageTab" style="cursor: pointer" @click="handleClickEngage()">
                <p class="tabText">Engage</p>
            </div>
            <div class="MarketInsightTab" style="cursor: pointer" @click="handleMarketIntelligence()">
                <p class="tabText">Market Insights</p>
            </div>
        </div> -->
        <div class="havingAcountButton" style="cursor: pointer" @click="goToLoginPage('login')">
            <p class="havingAcountButtonText">I have an account</p>
        </div>
        <div class="menuicondiv">
            <v-app-bar-nav-icon style="margin-bottom: 13px" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-navigation-drawer height="calc(100vh)" app right v-model="drawer">
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-icon style="margin-right: 0px; display: flex; justify-content: space-between">
                            <img height="24" width="24" src="../../../assets/logo/krishifyLogo.svg" />
                            <v-list-item-title style="text-align: center">
                                <p
                                    style="
                                        font-weight: 500;
                                        font-size: 16px;
                                        margin-top: 3px;
                                        text-transform: uppercase;
                                        color: #3a3f3a;
                                    "
                                >
                                    Krishify Business
                                </p>
                            </v-list-item-title>
                            <img
                                @click.stop="drawer = !drawer"
                                style="opacity: 0.5"
                                height="24"
                                width="24"
                                src="../../../assets/FrontPage/crossIcon.svg"
                            />
                        </v-list-item-icon>
                    </v-list-item-content>
                </v-list-item>
                <v-divider style="opacity: 0.5;"></v-divider>
                <!-- <v-list>
                    <v-list-item link style="height: 70px; text-align: left">
                        <v-list-item-content>
                            <v-list-item-title style="cursor: pointer" @click="handleClickadvertise()">
                                <p style="font-weight: 400; font-size: 18px; margin-bottom: 0px; color: #3a3f3a">
                                    Advertise with Krishify
                                </p>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider style="opacity: 0.5;"></v-divider>
                    <v-list-item link style="height: 70px; text-align: left">
                        <v-list-item-content>
                            <v-list-item-title style="cursor: pointer" @click="handleClickselling()">
                                <p
                                    style="
                                        font-weight: 400;
                                        font-size: 18px;
                                        margin-bottom: 0px;

                                        color: #3a3f3a;
                                    "
                                >
                                    Start Selling
                                </p>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider style="opacity: 0.5;"></v-divider>
                    <v-list-item link style="height: 70px; text-align: left">
                        <v-list-item-content>
                            <v-list-item-title style="cursor: pointer" @click="handleClickEngage()">
                                <p
                                    style="
                                        font-weight: 400;
                                        font-size: 18px;
                                        margin-bottom: 0px;

                                        color: #3a3f3a;
                                    "
                                >
                                    Engage Directly
                                </p>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider style="opacity: 0.5;"> </v-divider>
                    <v-list-item link style="height: 70px; text-align: left">
                        <v-list-item-content>
                            <v-list-item-title style="cursor: pointer" @click="handleMarketIntelligence()">
                                <p
                                    style="
                                        font-weight: 400;
                                        font-size: 18px;
                                        margin-bottom: 0px;

                                        color: #3a3f3a;
                                    "
                                >
                                    Market Insights
                                </p>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list> -->
                <template   v-slot:append  >
                    <div
                      
                        style="
                            background: green;
                            width: 80%;
                            margin: 0px auto;
                            height: 45px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-bottom: 20px;
                            cursor: pointer;
                            margin-top: 10px;
                        "
                        @click="goToLoginPage('register')"
                    >
                        <p
                            style="
                                color: white;
                                font-weight: 600;
                                font-size: 16px;
                                text-align: center;
                                margin-bottom: 0px;
                            "
                        >
                            Create account
                        </p>
                    </div>

                    <div
                        class="pa-6"
                        style="
                            background: #fbf9d4;
                            width: 80%;
                            margin: 0px auto;
                            height: 45px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-bottom: 20px;
                            cursor: pointer;
                        "
                        @click="handleclickReachUs()"
                    >
                        <p style="color: #3a3f3a; text-align: center; margin-bottom: 0px">Request a demo</p>
                    </div>

                    <div  style="cursor: pointer; 
                            width: 80%;
                            margin: 0px auto;
                            height: 45px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-bottom: 50px;
                            cursor: pointer;" @click="goToLoginPage('login')">
                        <p style="color: #339137; font-weight: 600; font-size: 16px; margin-bottom: 0px">
                            I have an account
                        </p>
                    </div>
                </template>
            </v-navigation-drawer>
            <!-- <img src="../../../assets/FrontPage/menu.svg" alt="" @click="this.drawer==true"/> -->
        </div>
    </div>
</template>

<script>
import MoengageEventGenerator from "../../../helpers/moengageEventGenerator";
import MoengageEvents from "../../../helpers/moengageEvents";
import MoengageAtrributes from "../../../helpers/moengageAttributes";
export default {
    name: "navigationHeader",
    data() {
        return {
            drawer: false,
            isMobile: false,
        };
    },
    props: {
        onclickselling: {
            type: Function,
            required: true,
        },
        onclickAdvertise: {
            type: Function,
            required: true,
        },
        onclickEngage: {
            type: Function,
            required: true,
        },
        onclickMarketIntelligence: {
            type: Function,
            required: true,
        },
        onclickReachUs: {
            type: Function,
            required: true,
        },
        
    },
    methods: {
        goToTOP() {
            console.log("goToTOP")
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        gtagEventHandler(eventName, attributeValue){
            this.$gtag.event(eventName, attributeValue);
        },

        checkDevices() {
            let details = navigator.userAgent;
            let regexp = /android|iphone|kindle|ipad/i;
            let isMobileDevice = regexp.test(details);

            this.isMobile = isMobileDevice;
        },
        goToLoginPage(type) {

            if(type=="login"){
            sessionStorage.setItem('buttonType','login');
            const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.ButtonClicked]:"I have an account",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            [MoengageAtrributes.NextActivity]:"Log In Page",
                        }
                        MoengageEventGenerator(MoengageEvents.LandingPageAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.LandingPageAction,moengageAttr);

            }
            else{  
                const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.ButtonClicked]:"Create Account",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            [MoengageAtrributes.NextActivity]:"Log In Page",
                        }
                        MoengageEventGenerator(MoengageEvents.LandingPageAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.LandingPageAction,moengageAttr);

                sessionStorage.setItem('buttonType','register');
        }
            if (this.isMobile) {
                this.$router.push({ name: "login" });
            } else {
                this.$router.push({ name: "login" });
            }
        },
        handleClickselling() {
            this.onclickselling();
            this.drawer = !this.drawer;
            const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.Action]:"Click",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            [MoengageAtrributes.LinkClicked]:"Start Selling",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                        }
                        MoengageEventGenerator(MoengageEvents.MenuSectionAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.MenuSectionAction,moengageAttr);

        },
        handleClickadvertise() {
            this.onclickAdvertise();
            this.drawer = !this.drawer;
            const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.Action]:"Click",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            [MoengageAtrributes.LinkClicked]:"Advertise with Krishify",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                        }
                        MoengageEventGenerator(MoengageEvents.MenuSectionAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.MenuSectionAction,moengageAttr);

        },
        handleClickEngage() {
            this.onclickEngage();
            this.drawer = !this.drawer;
            const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.Action]:"Click",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            [MoengageAtrributes.LinkClicked]:"Engage",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                        }
                        MoengageEventGenerator(MoengageEvents.MenuSectionAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.MenuSectionAction,moengageAttr);

        },
        handleMarketIntelligence() {
            this.onclickMarketIntelligence();
            this.drawer = !this.drawer;
            const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.Action]:"Click",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            [MoengageAtrributes.LinkClicked]:"Market Insights",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                        }
                        MoengageEventGenerator(MoengageEvents.MenuSectionAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.MenuSectionAction,moengageAttr);

        },
        handleclickReachUs() {
            this.onclickReachUs();
            this.drawer = !this.drawer;
            const moengageAttr={
                [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.ButtonClicked]:"Request for demo",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            [MoengageAtrributes.NextActivity]:"Reach Us Section",
                        }
                        MoengageEventGenerator(MoengageEvents.LandingPageAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.LandingPageAction,moengageAttr);

        },

        // navigateToAdvertise() {
        //     window.scrollTo({ top: 1750, behavior: "smooth" });
        //     this.drawer = !this.drawer;
        // },
        // navigateToStartSelling() {
        //     window.scrollTo({ top: 3150, behavior: "smooth" });
        //     this.drawer = !this.drawer;
        // },
        // navigateToEngageDirectly() {
        //     window.scrollTo({ top: 3900, behavior: "smooth" });
        //     this.drawer = !this.drawer;
        // },
        // navigateToMarkeInsights(){
        //     window.scrollTo({ top: 3900, behavior: "smooth" });
        //     this.drawer = !this.drawer;
        // }
    },
    mounted() {
        this.checkDevices();
    },
};
</script>

<style lang="scss" scoped>
.mainDiv {
    display: flex;
    background-color: #ffffff;
    justify-content: space-between;
    max-height: 88px;
    text-align: center;
    align-items: center;
    position: static;
    width:100%;
}

.logo {
    display: flex;
    justify-content: space-between;
    column-gap: 8px;
    margin-left: 14px;
    cursor: pointer;
}



.logoText {
    height: 19px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    text-transform: uppercase;
    color: #3a3f3a;
}

@media all and (max-width: 940px) {
    .havingAcountButtonText {
        font-size: 12px;
    }
}

@media all and (max-width: 940px) {
    .tabText {
        font-size: 12px;
    }
}

@media all and (max-width: 940px) {
    .navigationTabs {
        width: 50% !important;
    }
}

@media all and (max-width: 1024px) {
    .navigationTabs {
        display: none !important;
    }
}

@media all and (max-width: 1024px) {
    .havingAcountButton {
        display: none !important;
    }
}

@media all and (min-width: 1025px) {
    .menuicondiv {
        display: none !important;
    }
}

.navigationTabs {
    width: 40%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 13px;
}

.havingAcountButton {
    background: #f8f9f8;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 158px;
    height: 44px;
    margin-right: 14px;
}

.havingAcountButtonText {
    font-weight: 500;
    font-size: 14px;
    color: #339137;
    margin-bottom: 0px;
}

.tabText {
    height: 16px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #797e79;
}
</style>
